import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const InputDocumentContainer = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  gap: 8,
  alignItems: "center",
  "& div": {
    flexGrow: 1,
  },
  "& button": {
    fontSize: 12,
  },
  "& .MuiInputAdornment-root": {
    flexGrow: 0,
  },

  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: 0,
    "& .MuiFormControl-root": {
      marginBottom: theme.spacing(1.5),
      width: "100%",
    },
    "& button": {
      width: "100%",
    },
  },

  [theme.breakpoints.between("sm", "md")]: {
    flexWrap: "wrap",
    "& .MuiFormControl-root, & button": {
      width: "calc(50% - 4px)",
    },
  },
}));

export const DocumentsContainter = styled("div")(({ theme }) => ({
  marginTop: 16,
  "& h2": {
    fontWeight: 700,
  },
}));
export const ButtonPdfContainerStyled = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  gap: theme.spacing(0.5),

  "& button": {
    alignSelf: "stretch",
  },

  "& .error-text": {
    minHeight: "18px",
    fontSize: "0.75rem",
    color: theme.palette.error.main,
    textAlign: "left",
    width: "100%",
  },
}));

export const ButtonStyled = styled(Button)(({ theme }) => ({
  maxHeight: "40px",
  height: 40,
  whiteSpace: "nowrap",
  marginTop: 12,
}));
export const EquipmentListContainter = styled("div")(({ theme }) => ({
  maxHeight: "40vh",
  overflow: "auto",
  padding: "12px 0",
}));
